import {
  Component,
  effect,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DialogModule } from 'primeng/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { CodeMirrorEditorComponent } from '../../common/code-mirror-editor/code-mirror-editor.component';
import { UniqueIdService } from '../../services/builder/unique-id.service';
import { RulesService } from '../../services/builder/rules.service';

@Component({
  selector: 'lib-choose-showif-completion-component',
  template: `
    <p-dialog
      [(visible)]="visibility"
      [closable]="true"
      [modal]="false"
      [draggable]="false"
      [closeOnEscape]="true"
      [appendTo]="'body'"
      [position]="'top'"
      [header]="'Mostra se...'"
      (onHide)="hide.emit()"
      [styleClass]="'block md:min-w-180 lg:w-256 p-dialog-excel'"
    >
      @if (codeMirrorControl()) {
        <div class="flex flex-row items-center gap-2">
          <lib-code-mirror-editor
            [data]="elements.usedIds()"
            [formControl]="codeMirrorControl()"
            class="w-full"
            #currentCodeMirror
          ></lib-code-mirror-editor>

          <button
            (click)="hide.emit()"
            mat-icon-button
            color="accent"
            cdkFocusInitial
          >
            <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
          </button>
        </div>
      }
    </p-dialog>
  `,
  imports: [
    DialogModule,
    ReactiveFormsModule,
    MatIconModule,
    CodeMirrorEditorComponent,
    MatButtonModule,
  ],
})
export class ChooseShowIfCompletionComponent {
  protected elements = inject(UniqueIdService);
  private codeMirrorService = inject(RulesService);

  hide = output();
  currentCodeMirror = viewChild<CodeMirrorEditorComponent>('currentCodeMirror');
  codeMirrorControl = input.required<FormControl<string | null>>();

  protected visibility = true;

  constructor() {
    effect(() => {
      const clickedWidget = this.codeMirrorService.clickedWidget();
      if (!clickedWidget) return;

      const codeMirror = this.currentCodeMirror();
      if (!codeMirror) return;

      const currentlyUsing = this.codeMirrorControl();
      if (!currentlyUsing) return;

      currentlyUsing.setValue(currentlyUsing.value + `$${clickedWidget}$ `);
      codeMirror.updateCursor();

      this.codeMirrorService.clickedWidget.set(undefined);
    });
  }
}
